import mainRequest from '../request';

const mainUrl = `/v2/chatting`;

export const getChattingListRequest = async (params, type = 1) => {
    try {
        return await mainRequest.post(`${mainUrl}/list/${type}`, params);
    } catch (err) {
        return {
            ok: false,
            status: err.response.status || 500,
            message: err.response.data.message || '서버 에러',
        };
    }
};

export const patchChattingDisabledRequest = async (params) => {
    try {
        const response = await mainRequest.patch(`${mainUrl}/disable`, params);

        return response?.data;
    } catch (err) {
        return {
            ok: false,
            status: err.response.status || 500,
            message: err.response.data.message || '서버 에러',
        };
    }
};

export const getChattingDetailRequest = (chatId, { page = 1, size = 50, search = '' } = {}) =>
    mainRequest.get(`${mainUrl}/chat/${encodeURIComponent(chatId)}`, {
        params: { page, size, search },
    });

export const deleteChattingMessageRequest = (chatId, messageId) => mainRequest.patch(`${mainUrl}/chat/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}`);
